import React, { Component } from 'react';

class Help extends Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    return (
        <div className="container">
          <p>If you need help with Schindler E-Pay please contact us at <span><a href="mailto:epay_help.us@schindler.com">epayhelp@schindler.com</a></span></p>
        </div>
    );
  }
}
export default Help;
